import "ant-design-vue/es/modal/style";
import _Modal from "ant-design-vue/es/modal";
import { defineComponent, createVNode, computed, reactive } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { useService } from '@kaokei/use-vue-service';
import { ExamService } from '@/services/exam/exam.service';
import { useRoute } from 'vue-router';
import { value2label, QUESTION_TYPE, numberToLetter, formatDateToSecond, IS_QUESTION_TYPE_PROGRAM } from '@/utils';
import Image from './Image.vue';
import CustomAudio from './CustomAudio.vue';
import VideoDialog from './videoDialog/index.vue';
import { EyeOutlined, EditOutlined, ClockCircleOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  name: 'QuestionProgram',
  components: {
    Image: Image,
    CustomAudio: CustomAudio,
    EyeOutlined: EyeOutlined,
    EditOutlined: EditOutlined,
    ClockCircleOutlined: ClockCircleOutlined,
    VideoDialog: VideoDialog
  },
  props: {
    question: {
      type: Object,
      default: function () {
        return {};
      }
    },
    answerMode: {
      type: Boolean,
      default: false
    },
    hasPaperAnswer: {
      type: Boolean
    },
    markRecordData: {
      type: Object
    }
  },
  setup: function (_, _a) {
    var emit = _a.emit;
    var route = useRoute();
    var examService = useService(ExamService);
    var introVideoConf = reactive({
      visible: false,
      videoUrl: '',
      title: ''
    });
    var showIde = function () {
      if (examService.answerOrderLimit && !examService.hasFinishedObjective) {
        // 判断当前客观题还有多少题没有，并提示开始做主观题后将不能再次修改和查看客观题。确定后就直接上报
        var leftCount_1 = 0;
        examService.exam.questionsDtoList.forEach(function (item) {
          if (!IS_QUESTION_TYPE_PROGRAM(item.questionTypeId)) {
            item.questionDtoList.forEach(function (question) {
              if (question.questionStatus !== 'completed') {
                leftCount_1++;
              }
            });
          }
        });
        _Modal.confirm({
          title: (leftCount_1 ? "\u60A8\u5F53\u524D\u8FD8\u6709".concat(leftCount_1, "\u9053\u5BA2\u89C2\u9898\u672A\u4F5C\u7B54\uFF0C") : '') + '确定要开始答主观题吗？',
          icon: createVNode(ExclamationCircleOutlined),
          content: '开始主观题答题后，客观题将不可查看和修改',
          okText: '确认',
          cancelText: '取消',
          onOk: function () {
            examService.applyFinishObjectiveRecord().then(function () {
              examService.hasFinishedObjective = 1;
              emit('show');
            });
          }
        });
      } else {
        emit('show');
      }
    };
    var hidePreview = computed(function () {
      return Boolean(route.params.suffix === 'check');
    });
    var contentVideoList = computed(function () {
      try {
        var listStr = _.question.contentVideos || '[]';
        return JSON.parse(listStr);
      } catch (_a) {
        return [];
      }
    });
    var showVideoIntro = function (item) {
      introVideoConf.visible = true;
      introVideoConf.title = item.name;
      introVideoConf.videoUrl = item.url;
    };
    var configAudio = computed(function () {
      var _a;
      return ((_a = _.question.configData) === null || _a === void 0 ? void 0 : _a.audio) || {};
    });
    var qusesionAudioUrl = computed(function () {
      return configAudio.value.url || _.question.audioUrl || _.question.contentAudioUrl;
    });
    return {
      examService: examService,
      QUESTION_TYPE: QUESTION_TYPE,
      value2label: value2label,
      numberToLetter: numberToLetter,
      showIde: showIde,
      formatDateToSecond: formatDateToSecond,
      hidePreview: hidePreview,
      introVideoConf: introVideoConf,
      showVideoIntro: showVideoIntro,
      contentVideoList: contentVideoList,
      qusesionAudioUrl: qusesionAudioUrl
    };
  }
});